<template>
  <select ref="select2" :name="name" class="form-control"></select>
</template>

<script>

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/css/select2.min.css';
  import 'select2-bootstrap-theme/dist/select2-bootstrap.min.css';
  import i18n from "../../../shared/i18n";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "Select2",
    props: {
      name: String,
      items: {
        Object
      },
      value: {
        required: true
      },
      options: {
        type: Object,
        default: () => {
        }
      },
      tags: {
        type: [Boolean, Array],
        default: false
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      displayField: {
        type: [String, Function],
        default: 'text'
      },
      displayFieldForSelection: {
        type: [String, Function],
        default: null
      },
      searchHandler: {
        type: Function,
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        select2data: [],
        isInitial: true
      }
    },
    watch: {
      items() {
        this.init();
      },
      value() {
        let value = this.value
        let $el = $(this.$refs.select2)

        /*
         *  This may change in future. The reason why we need such code is that when select2 is not in ajax mode, is
         *  predefined items array, then initialization is called only once. But if we call this code below on ajax
         *  select2 inputs, then selectionFunction will be called multiple times, which is common select2 issue.
         */
        if (!this.searchHandler && this.options && !this.options.multiple && !this.multiple && !this.options.ajax) {
          $el.val(value).trigger("change");
        }

        if (!this.searchHandler && this.options && !this.options.ajax && this.multiple) {
          // check to see if the arrays contain the same values
          if ([...value].sort().join(",") !== [...$el.val()].sort().join(",")) {
            $el.val(value).trigger("change")
          }
        }
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      evaluateDisplayField(item) {
        if (typeof this.displayField === 'function') {
          return this.displayField(item);
        }
        return eval('`' + this.displayField + '`');
      },
      evaluateDisplayFieldForSelection(item) {
        if (!this.displayFieldForSelection) {
          return this.evaluateDisplayField(item)
        }

        if (typeof this.displayFieldForSelection === 'function') {
          return this.displayFieldForSelection(item);
        }
        return eval('`' + this.displayFieldForSelection + '`');
      },
      init() {
        this.isInitial = true;
        this.destroy();
        this.initSelect2Data();

        let vm = this;
        let select = $(vm.$refs.select2);
        let params = this.prepareParams();

        // Following code properly clears previous data
        if (!this.options.multiple) {
          select.html('').select2({data: [{id: '', text: ''}]});
        }
        select.select2(params)
          .on('change', (e) => {
            $(e.target).parents().off("scroll.select2")
            // Should not emit input change on intial value change
            if (!vm.isInitial) {
              vm.$emit('input', select.val())
            }
          })
          .on('select2:close', () => vm.$emit('blur'))
          .on('select2:select', (eventData) => vm.$emit('select', eventData.params.data))
          .on('select2:unselect', (eventData) => vm.$emit('unselect', eventData.params.data))
          .on('select2:clearing', (eventData) => $(this.$refs.select2).val([]).trigger("change"))
          .on('select2:clear', (eventData) => vm.$emit('clear', eventData.params.data))
          .val(this.value)
          .trigger('change');

        vm.isInitial = false;
      },
      destroy() {
        if ($(this.$refs.select2).hasClass('select2-hidden-accessible')) {
          $(this.$refs.select2).off().select2('destroy')
        }
      },
      initSelect2Data() {
        this.select2data = [];

        if (Array.isArray(this.items)) {
          this.select2data = this.items.map(item => {
            return {
              ...item,
              id: item[this.valueField],
              text: this.evaluateDisplayField(item)
            }
          });
          if (!this.options.multiple) {
            this.select2data.unshift({
              id: '',
              text: i18n.t('Select'),
            });
          }
        } else {
          for (let index in this.items) {
            this.select2data.push({id: this.items[index].uuid || index, text: this.items[index]})
          }
        }
      },

      createTagFunction(params) {
        const term = $.trim(params.term);

        if (term === '') {
          return null;
        }

        return {
          id: term,
          key: term,
          value: term,
          isNew: true
        }
      },

      prepareParams() {
        let vm = this;

        let templateForResult = (item) => {
          return item.id ? this.evaluateDisplayField(item) : item.text;
        };
        let templateForSelection = (item) => {
          return item.id ? this.evaluateDisplayFieldForSelection(item) : item.text;
        };

        let params = {
          placeholder: i18n.t('Select'),
          theme: 'bootstrap',
          tags: vm.tags,
          multiple: vm.multiple,
          createTag: vm.createTagFunction,
          width: '100%',
          allowClear: true,
          templateResult: templateForResult,
          templateSelection: templateForSelection,
          data: this.select2data,
          language: {
            inputTooShort: function (args) {
              let remainingChars = args.minimum - args.input.length;
              return vm.$i18n.t("Please enter {remainingChars} or more characters", {remainingChars})
            },
            errorLoading: function () {
              return vm.$i18n.t('The results could not be loaded.');
            },
            inputTooLong: function (args) {
              let overChars = args.input.length - args.maximum;

              return vm.$i18n.t('Please delete ${overChars} character(s)', {overChars});
            },
            loadingMore: function () {
              return vm.$i18n.t('Loading more results…');
            },
            maximumSelected: function (args) {
              return vm.$i18n.t('You can only select {maximum} item', {maximum: args.maximum});
            },
            noResults: function () {
              return vm.$i18n.t('No results found');
            },
            searching: function () {
              return vm.$i18n.t('Searching…');
            },
            removeAllItems: function () {
              return vm.$i18n.t('Remove all items');
            }
          }
        };

        // This initiates autocomplete search select2 field
        if (this.searchHandler) {
          params.minimumInputLength = 1;
          params.ajax = {
            dataType: 'json',
            delay: 500,
            data: function (params) {
              return {
                txt: params.term,
              };
            },
            transport: async function (params, success, failure) {
              let response = await vm.searchHandler(params.data.txt);
              response.success ? success(response.body.results) : failure();
            },
            processResults: function (data, params) {
              data.map(obj => obj.id = obj[vm.valueField]);
              return {
                results: data,
              };
            },
          };
        }

        params = {...params, ...this.options};

        return params;
      }
    },
    destroyed() {
      this.destroy();
    }
  }
</script>

<style>
  .select2-search__field {
    width: 100% !important;
  }

  .select2-selection__rendered li:nth-last-child(2) {
    clear: left;
  }

  .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice {
    clear: unset;
  }
</style>
